import { Injectable, Signal } from '@angular/core';
import { ICustomerData, ICustomerModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { CustomerActions, CustomerSelectors, ICustomerState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class CustomerStore extends StateAccessService<ICustomerState> {
  readonly state$: Observable<ICustomerState>;

  readonly data$$: Signal<ICustomerData>;
  readonly model$$: Signal<ICustomerModel>;

  readonly hasCustomerResponse$$: Signal<boolean>;

  constructor() {
    super();

    this.state$ = this.stateFacade.select$(CustomerSelectors.customerState);

    this.model$$ = this.stateFacade.selectSignal$(CustomerSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(CustomerSelectors.data);

    this.hasCustomerResponse$$ = this.stateFacade.selectSignal$(CustomerSelectors.hasCustomerResponse);
  }

  dispatchCustomerReset() {
    this.stateFacade.dispatch(CustomerActions.reset());
  }
  dispatchCustomerLoad() {
    this.stateFacade.dispatch(CustomerActions.load());
  }
  dispatchCustomerLoadSuccess({ model, data }: { model: ICustomerModel; data: ICustomerData }) {
    this.stateFacade.dispatch(CustomerActions.loadSuccess({ model, data }));
  }
}
